<template>
  <VueMeta />
  <Layout />
</template>
<script lang="ts">
import { defineComponent } from '@vue/runtime-core'

import VueMeta from '@/global/plugins/vue-meta/component'
import Layout from '@/layout'

export default defineComponent({
  name: 'App',
  components: {
    VueMeta,
    Layout,
  },

  mounted () {
    if (/iphone/.test(navigator.userAgent.toLocaleLowerCase()) && (window.innerHeight > 800 || window.devicePixelRatio === 3)) {
      document.body.classList.add('ipx')
    }
  },
})
</script>
